import { Stack, Button, Table, Form, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import React, { forwardRef } from 'react';
import { HashLink } from "react-router-hash-link";
import { useNavigate, useLocation } from "react-router-dom";
import LaunchIcon from '@mui/icons-material/FileDownloadOutlined';
import { Link } from "react-router-dom";
import { ICONS } from "Utils/icons";
import { getResourceDownloadProps } from "Utils/fileDownloadUtil";
import { PATHS } from "Utils/PagePaths";


var getValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};

function addClass (propClasses, className) {
  var classes = "";
  if (propClasses != null) {
    var arr = propClasses.split(" ").map(function (value) {
      return value.trim();
    });
    var isIncluded = arr.includes(className.trim());
    if (isIncluded) {
      classes = propClasses;
    }
    else {
      classes = propClasses.concat(" " + className);
    }
  }
  else {
    classes = className;
  }

  return classes;
}

export const TextButton = forwardRef((props,ref) => {
    var classes = addClass(props.className, "text-button");
    if(props.hasOwnProperty("groupId") && props.groupId!=null){
        var groupId = props.groupId;
        if(props.hasOwnProperty("isArticle") && props.isArticle!=null && props.isArticle == true){
            return (
                <Button {...props} 
                    ref={ref} 
                    className={classes}
                    to={PATHS.public.Article.replace(":id",groupId)} 
                    
                    as={Link} 
                    //target="_blank" 
                >
                    <div>{props.content}</div>
                </Button>
            )
        }
        else{
            return (
                <Button {...props} 
                    ref={ref} 
                    className={classes}
                    // to={getDocURL(groupId)} 
                    // as={Link} 
                    // target="_blank" 
                    {...getResourceDownloadProps(groupId)}
                >
                    <div>{props.content}</div>
                </Button>
            )
        }
        
    }
    else{
        return (
        <Button {...props} ref={ref} className={classes}>
            <div>{props.content}</div>
        </Button>
    )
    }

    
})

export const IconTextButton = React.forwardRef((props, ref) => {
    var classes = addClass(props.className, "icon-text-button");
    

    if(props.hasOwnProperty("groupId") && props.groupId!=null){
        var groupId = props.groupId;
        if(props.hasOwnProperty("isArticle") && props.isArticle!=null && props.isArticle == true){
            return (
                <Button {...props}
                    className={classes}
                    to={PATHS.public.Article.replace(":id",groupId)} 
                    as={Link} 
                >
                    <Stack direction="horizontal" gap={2}>
                        <div className="buttonIcon">
                            {props.icon()}
                        </div>
                        <div className="buttonText">
                            <>{props.content}</>
                        </div>
                    </Stack>
                </Button>
            )
        }
        else{
            return (
                <Button {...props}
                    className={classes}
                    {...getResourceDownloadProps(groupId)}

                    //to={getDocURL(groupId)} 
                    //as={Link} 
                    //target="_blank" 
                >
                    <Stack direction="horizontal" gap={2}>
                        <div className="buttonIcon">
                            {props.icon()}
                        </div>
                        <div className="buttonText">
                            <>{props.content}</>
                        </div>
                    </Stack>
                </Button>
            )
        }
    }
    else{
        return (
            <Button {...props} className={classes}>
                <Stack direction="horizontal" gap={2}>
                    <div className="buttonIcon">
                        {props.icon()}
                    </div>
                    <div className="buttonText">
                        <>{props.content}</>
                    </div>
                </Stack>
            </Button>
        )
    }
    
})

export const CenteredIconTextButton = (props) => {
  var classes = addClass(props.className, "icon-text-button");

  return (
    <Button {...props} className={classes}>
      <Stack direction="horizontal" className="justify-content-center" gap={2}>
        <div className="buttonIcon">
          {props.icon()}
        </div>
        <div className="buttonText">
          <>{props.content}</>
        </div>
      </Stack>
    </Button>
  )
}

export const IconButton = React.forwardRef((props, ref) => {
  var classes = addClass(props.className, "icon-button");

  return (
    <Button {...props} ref={ref} className={classes} aria-label={props.id}>
      <div className="buttonIcon">
        {getValue(props.icon)}
      </div>
      {props.hiddenText!=null
        ?   <span class="visually-hidden">{props.hiddenText}</span>
        :    null
      
      }
      
    </Button>
  )
});


export const BackToTopButton = (props) => {
  var classes = addClass(props.className, "back-to-top-button back-to-top-button fade-in btn btn-normal");
  const location = useLocation();
  var allClasses = classes + " " + props.fadeClass;
  var tabIndex = props.tabIndex;

  return (
    <>
        {/* <HashLink to={location.pathname} tabIndex={tabIndex} state={location.state} className={allClasses} fadeClass={"fade-out"} elementId="mainContent" onClick={props.onClick}>
            <Stack direction="horizontal" gap={2}>
                <div className="buttonText">
                    <>{props.content}</>
                </div>
                <div className="buttonIcon">
                    {props.icon()}
                </div>
            </Stack>
        </HashLink> */}
        <HashLink to={location.pathname} tabIndex={tabIndex} state={location.state} className={allClasses} fadeClass={"fade-out"} elementId="mainContent" onClick={props.onClick}>
            <Stack direction="horizontal" gap={2}>
                <div className="buttonText">
                    <>{props.content}</>
                </div>
                <div className="buttonIcon">
                    {props.icon()}
                </div>
            </Stack>
        </HashLink>
    {/*<Button variant={props.variant} onClick={props.onClick} className={allClasses}>
      <Stack direction="horizontal" gap={2}>
        <div className="buttonText">
          <>{props.content}</>
        </div>
        <div className="buttonIcon">
          {props.icon()}
        </div>
      </Stack>
    </Button>*/}
    </>
  )
}

export const BackToTopButtonNew = (props) => {
  var classes = addClass(props.className, "back-to-top-button-new btn p-0  bottom-0 w-auto");
  const location = useLocation();
  var allClasses = classes + " " + props.fadeClass;
  var tabIndex = props.tabIndex;

  return (
    <>
        {/* <HashLink to={location.pathname} tabIndex={tabIndex} state={location.state} className={allClasses} fadeClass={"fade-out"} elementId="mainContent" onClick={props.onClick}>
           
                <div className="buttonIcon">
                    {props.icon()}
                </div>
                {props.hiddenText!=null
                    ?   <span class="visually-hidden">{props.hiddenText}</span>
                    :    null
                
                }
                
               
           
        </HashLink> */}
        {/* <OverlayTrigger
            placement={"top"}
            //show={true}
            overlay={
                <Tooltip id="submit-all-tooltip" >
                    Back to Top
                </Tooltip>
            }
        > */}
            <IconButton
                id="btt-btn"
                content={props.content}
                variant="comp-primary"
                size="lg"
                icon={props.icon()}
                className="body p-2 back-to-top-button-new "
                onClick={props.onClick}
                hiddenText={"Back to Top"}
                title="Back to Top"
            ></IconButton>
        {/* </OverlayTrigger> */}
    </>
  )
}

export const NotificationButton = (props) => {
  var classes = addClass(props.className, "notification-button");

  return (
    <Button {...props} className={classes} aria-label="Notifications" title="Notifications" >
      <div className="notificationDot">

      </div>
      <div className="buttonIcon">
        {props.icon()}
      </div>

    </Button>
  )
}

export const TableIconTextButton = (props) => {
  var classes = addClass(props.className, "table-icon-text-button");

  return (
    <Button {...props} className={classes}>
        <Stack direction="horizontal" className="w-100">
            
            <div className="buttonText text-start">
                <>{props.content}</>
            </div>
            
            {   
                props.icon!=null 
                ?   <div className="ms-auto buttonIcon ">
                        {props.icon()}
                    </div>
                : null
            }
      </Stack>
    </Button>
  )
}

export const LinkButton = (props) => {
  var classes = addClass(props.className, "link-button");

  return (
    <Button {...props} as={Link} variant="link" className={classes}>
        <Stack direction="horizontal" className="w-100">
            
            <span className="d-inline-block mt-1">
                <>{props.content}</>
            </span>
            
            {   
                props.external!=null && props.external==true 
                ?   <LaunchIcon className="ms-2 "></LaunchIcon>
                : null
            }
      </Stack>
    </Button>
  )
}

